import { Component } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { ProviderSets } from "./ProviderSets";
import { ProviderSetDetail } from "./providerSetDetail/ProviderSetDetail";
import { ProviderDetails } from "./ProviderDetails";

export default class ProviderSetsRouter extends Component<RouteComponentProps<unknown>> {
  constructor(props: RouteComponentProps<unknown>) {
    super(props);
  }

  public render() {
    return (
      <Switch>
        <Route
          exact={true}
          path={`${this.props.match.url}/manager`}
          component={ProviderSets}
        />
        <Route
          exact={true}
          path={`${this.props.match.url}/:providerSetId/detail`}
          component={ProviderSetDetail}
        />
        <Route
          exact={true}
          path={`${this.props.match.url}/:providerSetId/version/:versionId/detail`}
          component={ProviderSetDetail}
        />
        <Route
          exact={true}
          path={`${this.props.match.url}/:providerSetId/version/:versionId/providers/:summaryType/:filter`}
          component={ProviderDetails}
        />
        <Route
          exact={true}
          path={`${this.props.match.url}/:providerSetId/version/:versionId/providers`}
          component={ProviderDetails}
        />
      </Switch>
    );
  }
}
